export function generateDataItem() {
    function displayMetadata(item) {
        let urlArray;
        try {
            urlArray = new URL(item.metadata?.image).pathname.split('/');
        } catch (e) {
            urlArray = ['', '', ''];
        }
        const [, , artifactTypeId] = urlArray;

        return {
            id: item.main_id,
            name: item.metadata.name,
            image: item.metadata.image, // square image
            thumbnail_image: item.metadata.thumbnail_image, // video thumbnail
            token_id: item.metadata.token_id,
            icon_path: item.metadata.icon_url,
            owner_name: item.metadata.owner_name,
            animation_url: item.metadata.animation_url,
            artifact_type: item.artifact_type,
            artifact_type_id: artifactTypeId, // TODO ask BE nicely for this from the api
        };
    }

    function ownedIds(item) {
        return [...item.owned, ...item.used];
    }

    function mintingData(artifact) {
        const mintedIds = artifact.used_on_chain?.concat(artifact.owned_on_chain);
        return {
            lootbox_token_id_mapping: artifact.lootbox_token_id_mapping,
            contract_address: artifact.contract_address,
            eligible_for_minting: artifact.eligible_for_minting,
            minting_enabled: artifact.minting_enabled,
            owned_on_chain: artifact.owned_on_chain,
            used_on_chain: artifact.used_on_chain,
            burn_address: artifact.burn_address,
            fungible: artifact.fungible,
            token_id: artifact.token_id,
            owned: artifact.owned,
            used: artifact.used,
            mintedIds,
        };
    }

    function mintDisplayItem(displayData, mintData, mintBreakdown, artifactId?) {
        return {
            ...displayData,
            ...mintData,
            ...mintBreakdown,
            artifactId,
        };
    }

    return { displayMetadata, mintingData, ownedIds, mintDisplayItem };
}
